import React, { useEffect } from 'react';
import SliderSortOrderTree from './SliderSortOrderTree.jsx';
import { Spinner } from '../../../../common';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { useTranslation } from 'react-i18next';
import { useToastMessages } from '../../../../../hooks/useToastMessages';
import {
  useGetSlidersQuery,
  useSaveSlidersOrderMutation,
} from '../../../../../redux/services/sliders';
import { useNavigate } from 'react-router-dom';

const SliderOrderPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { data: sliders, isLoading } = useGetSlidersQuery();

  useEffect(() => {
    document.title = t('Úprava poradia banerov') + ' - FRI CMS';
  }, []); // Runs on mount

  const [saveSlidersOrder, { isSuccess: isSaveSuccess }] =
    useSaveSlidersOrderMutation();

  const { saveSuccess: showSaveSuccess } = useToastMessages();

  useEffect(() => {
    if (isSaveSuccess) {
      showSaveSuccess();
      navigate(routes.cmsSliders);
    }
  }, [isSaveSuccess]);

  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Úprava poradia banerov')}
        backUrl={routes.cmsSliders}
        backUrlTooltip={t('Tabuľka obrázkov')}
        permissionsBasic={'sliders'}
      />

      <SliderSortOrderTree
        sliders={sliders}
        onOrderSave={(slidersData) => saveSlidersOrder(slidersData)}
      />
    </>
  );
};

export default SliderOrderPage;
